<template>
  <SelectBase
    :downshift-props="{
      disabled: disabled || readonly,
      items: [],
      ...downshiftProps,
    }"
    :show-action="false"
    :skip-option-bs="true"
    :popover-props="mergedPopoverProps"
  >
    <template
      #select="{
        toggleOpen, isOpen,
      }"
    >
      <SelectTagButton
        :items="items"
        :is-open="isOpen"
        input-mode="select"
        :readonly="readonly"
        v-bind="$attrs"
        :remove-item="removeItem"
        :disabled="disabled"
        :bs="bs"
        @click="() => toggleOpen()"
      />
    </template>

    <template #options>
      <NewBsBox
        :bs="{ maxWidth: 800, overflow: 'auto'}"
      >
        <Tree
          ref="tree"
          :model-value="modelValue"
          :bs="{ border: 'none' }"
          v-bind="treeProps"
          @update:modelValue="onChange"
        />
      </NewBsBox>
    </template>
  </SelectBase>
</template>

<script>
  import { merge } from 'lodash'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import Tree from './Tree.vue'
  import SelectTagButton from '../SelectTagButton.vue'
  import SelectBase from '../SelectBase.vue'

  /**
   * 下拉级联多选
   * @model modelValue|@update:modelValue
   */
  export default {
    name: 'MultiCascadeSelect',
    components: {
      SelectBase,
      SelectTagButton,
      NewBsBox,
      Tree,
    },
    model: {
      prop: 'modelValue',
      event: 'update:modelValue',
    },
    props: {
      /**
       * 透传给 Tree 的 props
       */
      treeProps: {
        type: Object,
        default: () => ({}),
      },
      modelValue: {
        type: Array,
      },
      /**
       * 是否只读
       */
      readonly: {
        type: Boolean,
        default: false,
      },
      /**
       * 是否禁止选
       */
      disabled: {
        type: Boolean,
        default: false,
      },
      /**
       * placeholder
       */
      placeholder: {
        type: String,
        default: '请输入',
      },
      /**
       * 选项 SelectButton 的 inline 样式
       */
      bs: {
        type: Object,
        default: () => ({}),
      },
      /**
       * 透传给 downshift 的参数
       */
      downshiftProps: {
        type: Object,
        default: () => ({}),
      },
      /**
       * 透传给 popover 参数
       */
      popoverProps: {
        type: Object,
        default: () => ({}),
      },
      /**
       * 透传给 input 参数
       */
      inputProps: {
        type: Object,
        default: () => ({}),
      },
    },
    emits: ['update:modelValue'],
    data() {
      return {
        itemNameByIdentity: {},
      }
    },
    computed: {
      items() {
        return this.modelValue?.map(i => ({
          id: i,
          text: this.optionItemToText(i),
        })) || []
      },
      mergedPopoverProps() {
        return merge({
          ...this.popoverProps,
        }, {
          keepMounted: true,
          statelessBs: {
            py: 0,
            border: '1px solid #D9D9D9',
            borderRadius: 'control',
          },
        })
      },
    },
    mounted() {
      this.$watch(
        () => this.$refs.tree?.itemNameByIdentity,
        val => {
          this.itemNameByIdentity = val
        },
      )
    },
    methods: {
      removeItem(value) {
        const val = this.modelValue.filter(v => v !== value.id)
        this.$emit('update:modelValue', val, {
          itemNameByIdentity: this.itemNameByIdentity,
        })
      },
      onChange(value, context) {
        this.$emit('update:modelValue', value, context)
      },
      optionItemToText(id) {
        return this.itemNameByIdentity[id] || id
      },
    },
  }
</script>
